
import { Component, Emit, Vue } from 'vue-property-decorator'
import BasicButton from '@mg/web-components/Atoms/Buttons/BasicButton'
import { FbStatusResponse, FbLoginOptions, FB } from './HeaderUserLoginFb.types'
import { GQLConfig } from '~/graphql/__generated__/interfaces'
import { GET_CONFIG } from '~/graphql/gql/config'

@Component({
  apollo: {
    getConfig: {
      fetchPolicy: 'cache-only',
      query: GET_CONFIG,
    },
  },
  components: {
    UserFbButton: BasicButton,
  },
})
export default class HeaderUserLoginFb extends Vue {
  readonly SDK_VERSION = 'v3.3'
  readonly SDK_SRC = 'https://connect.facebook.net/en_US/sdk.js'
  readonly SCOPE = 'public_profile,email'

  getConfig: GQLConfig
  loading = false

  @Emit('onLoggedIn')
  onLoggedIn() {
    return true
  }

  async facebookLogin() {
    this.loading = true

    await this.loadScript(this.SDK_SRC)

    const fb = this.initFacebook(
      this.getConfig.shopConfig.fbAppId,
      this.SDK_VERSION
    )

    const login = await this.login(fb, {
      scope: this.SCOPE,
    })

    if (!login.authResponse) {
      this.loading = false
      return
    }

    await this.$webApi.loginFb({
      isFacebook: true,
      token: login.authResponse.accessToken,
      userId: login.authResponse.userID,
    })

    this.loading = false

    this.onLoggedIn()
  }

  loadScript(src: string) {
    return new Promise(function (resolve, reject) {
      const scriptElement = document.createElement('script')
      scriptElement.src = src
      scriptElement.onload = resolve
      scriptElement.onerror = reject
      document.head.appendChild(scriptElement)
    })
  }

  initFacebook(appId: string, version: string) {
    const wind = window as any
    const fb = wind.FB as FB
    fb.init({
      appId,
      autoLogAppEvents: true,
      cookie: true,
      status: true,
      version,
      xfbml: true,
    })

    return fb
  }

  login(fb: FB, params: FbLoginOptions): Promise<FbStatusResponse> {
    return new Promise((resolve) => {
      fb.login((response: FbStatusResponse) => {
        resolve(response)
      }, params)
    })
  }
}
